import { render, staticRenderFns } from "./MensageriaExterna.vue?vue&type=template&id=2fe9360e&scoped=true"
import script from "./MensageriaExterna.vue?vue&type=script&lang=js"
export * from "./MensageriaExterna.vue?vue&type=script&lang=js"
import style0 from "./MensageriaExterna.vue?vue&type=style&index=0&id=2fe9360e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9360e",
  null
  
)

export default component.exports